import AuthorizedImage from './AuthorizedImage';

export default AuthorizedImage;
